// extracted by mini-css-extract-plugin
module.exports = {"infosContainer":"style_infosContainer__j2sU-","infos":"style_infos__AZaUC","title":"style_title__2INHu","btnUploadContainer":"style_btnUploadContainer__2XLYg"};